import { createSelector } from 'reselect'
import selectTrelloMembersById from './selectTrelloMembersById'

export default createSelector(selectTrelloMembersById, members => {
  if (!members) return members
  return Object.values(members)
})
